import moment from 'moment'
import "moment/locale/es";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
const ExcelJS = require('exceljs');
moment.locale("es"); 

export const consolidateReport = async (data, id, dateStart, user) => {

    let movements = []
    let totalValue = 0;
    data.map(column => {
        column.NumeroCuentaDestino = column.data.NumeroCuentaDestino
        column.Institucion = column.data.Institucion
        totalValue += parseFloat(column.data.Monto) || 0;
        movements.push(column)
        return column
    })

    const workbook = new ExcelJS.Workbook();
    workbook.addWorksheet("sheet1");
    const worksheet = workbook.getWorksheet("sheet1");

    const cabeceras = [
        'NOMBRE',//1
        'CUENTA', //2
        'INSTITUCION',//3
        'VALOR',//4
    ];

    worksheet.getCell('A2').value = 'Cliente'
    worksheet.getCell('B2').value = `${user.customer.first_name} ${user.customer.surname}`
    worksheet.getCell('A3').value = 'Fecha'
    worksheet.getCell('B3').value = moment(dateStart).format('DD/MM/YYYY');

    worksheet.views = [
        { state: 'worksheet', zoomScale: 127, }
    ];

    const fuenteHoja = 'Calibri';

    const cabeceraColorHoja = '1C1B17';
    const tamanoContenido = 12;

    const rowHeader = worksheet.addRow(
        cabeceras
    );
    var borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
    };

    var borderStyleHeader = {
        left: { style: "thin", color: { argb: 'ffffff' } },
        right: { style: "thin", color: { argb: 'ffffff' } }
    };

    rowHeader.eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: cabeceraColorHoja },
            bgColor: { argb: '' }
        };
        cell.font = {
            size: tamanoContenido,
            bold: true,
            color: { argb: 'ffffff' },
        };
        cell.alignment = {
            vertical: 'middle',
            horizontal: 'center'
        };
        cell.border = borderStyleHeader;
    });

    worksheet.columns = [
        { header: "", key: "name" },
        { header: "", key: "NumeroCuentaDestino" },
        { header: "", key: "Institucion" },
        { header: "", key: "value" },

    ];
    movements.forEach((value) => {
        worksheet.addRow(value).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = {
                name: fuenteHoja,
                size: tamanoContenido,
            };
            cell.border = borderStyle;
        })
    })
    worksheet.getCell(`D${worksheet.lastRow.number + 1}`).value = totalValue

    const uint8Array = await workbook.xlsx.writeBuffer()

    const blob = new Blob([uint8Array], { type: "application/octet-binary" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Rol de Pagos ${moment(dateStart).format('DD/MM/YYYY')}.xlsx`;
    a.click();
    a.remove();
}


export const consolidateReportPDF = (data, id, dateStart, user, arr, row) => {

    let movements = [];
    let totalValue = 0;

    data.forEach(column => {        
        column.NumeroCuentaDestino = column.data.NumeroCuentaDestino;
        column.Institucion = column.data.Institucion;
        totalValue += parseFloat(column.data.Monto) || 0;
        column.Secuencial = column.data.Institucion;
        column.fechaFormateada = column.data.Fecha ?  moment(column.data.Fecha).format("DD [de] MMMM [de] YYYY").replace(/^\w/, (c) => c.toUpperCase() ) : '';
        movements.push(column);
    });

    const doc = new jsPDF({
        orientation: 'landscape', 
        unit: 'mm',
        format: 'a4'
    });

    doc.setFillColor(0, 154, 168);
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), 30, 'F');

    const img = new Image();
    img.src = process.env.PUBLIC_URL + '/images/logo_voucher.png';
    img.onload = function () {
        doc.addImage(img, 'PNG', 10, 10, 50, 15);

        doc.setFontSize(14);
        doc.setTextColor(0, 0, 0);
        const pageWidth = doc.internal.pageSize.getWidth();
        const centerText = (pageWidth - doc.getTextWidth("Rol de Pagos")) / 2;

        doc.text(`Rol de Pagos`, centerText, 50);

        doc.setFontSize(10);
        doc.text(`Cliente: ${user.companies.name || "N/A"}`, 10, 60);
        doc.text(`Fecha: ${data[0].data.Fecha ? moment(data[0].data.Fecha).format("DD/MM/YYYY") : "N/A"}`, 10, 70);        
        doc.text(`Total: $${totalValue.toFixed(2)}`, 10, 80);
        

        const tableData = movements.map(mov => [
            mov.payroll || '',
            'NOTA DE DEBITO TRANSFERENCIA CUENTAS',
            `$ ${mov.value || '0.00'}`,
            `$ 0.00`,
            `WEB`,
            mov.data.documento ||  mov.data.Documento || '',
            mov.data.Fecha ? moment(mov.data.Fecha).format("DD/MM/YYYY") : '',
            // mov.data.Concepto || ''
            `PAGO ROL ${mov.fechaFormateada ? mov.fechaFormateada : ''}  -Beneficiario: ${mov.data.Beneficiario || mov.name} -Cuenta: ${mov.data.NumeroCuentaDestino}` || ''
        ]);

        doc.autoTable({
            startY: 90,
            head: [["Secuencial", "Transacción", "Valor Efectivo", "Valor Cheque", "Usuario", "Documento", "Fecha", "Concepto"]],
            body: tableData,
            theme: "striped",
            headStyles: {
                fillColor: [0, 154, 168],
                textColor: [255, 255, 255],
                fontStyle: "bold",
                halign: "center",
            },
            styles: {
                fontSize: 7, 
            },
            didDrawPage: (data) => {
                if (data.pageNumber === 1) {
                    doc.setFillColor(0, 154, 168);
                    doc.rect(0, 0, doc.internal.pageSize.getWidth(), 30, 'F');
                    doc.addImage(img, 'PNG', 10, 10, 50, 15);
                }
            },
        });

        doc.output('dataurlnewwindow');
    };
};
